import React from 'react';
import Text from 'common/components/Text/Text';
import styles from 'features/user/dashboard/pages/dashboard/Dashboard.module.scss';

const ExpertCard = (): React.ReactElement => {
  return (
    <div className={styles.expertBox}>
      <div className={styles.expertPhoto}>
        <i className="bi bi-person-circle"></i>
      </div>
      <div className={styles.expertInfo}>
        <Text size={18} weight={600}>
          Patricia Miraflores
        </Text>
        <Text size={12} color="secondary">
          patricia@unifyapply.com
        </Text>
        <div className={styles.buttonsContainer}>
          <a href="mailto:patricia@unifyapply.com">
            <div className={styles.button}>Contact</div>
          </a>
          <div className={styles.button} onClick={() => window.open('/experts/request-meeting')}>
            Book meeting
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertCard;
